module.exports = __webpack_public_path__ + "static/media/top20_tile.42056d07.jpg";